// @flow strict

import * as React from 'react';
// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';
import PageContentBlock from '../../internal/PageContentBlock';
import Pagination from '../../internal/Pagination';
import Partners, { type PropsType as PartnerPropsType } from './Internal/Partners';

type PropTypes = {|
  title: string,
  image: string,
  page: number,
  totalPages: number,
  urlTemplate: string,
  ...PartnerPropsType,
|};

export const PartnerLanding = (props: PropTypes) => {
  const containerRef = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (containerRef.current && typeof window !== 'undefined' && window.location.search) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'center' });
    }
  }, []);
  return (
    <>
      <PageContentBlock className={styles.header} title={props.title} image={props.image} />
      <div ref={containerRef}>
        <Partners
          partners={props.partners}
          action={props.action}
          fieldName={props.fieldName}
          searchTerm={props.searchTerm}
          location={props.location}
          service={props.service}
          industry={props.industry}
          locations={props.locations}
          services={props.services}
          industries={props.industries}
        />
        <div className={styles.pagination}>
          <Pagination
            selected={props.page}
            total={props.totalPages}
            urlTemplate={props.urlTemplate}
          />
        </div>
      </div>
    </>
  );
};
